import { Button } from '@metadevprofile/ui/web';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { authRoutes } from '@/auth/constants/routes';
import { PageHelmet } from '@/common/components/page-helmet';

export function NotFoundPage() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <>
      <PageHelmet title={t('notFound.title')} />
      <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center">
        <p className="text-8xl font-bold text-primary">404</p>
        <h1 className="mt-4 text-2xl font-semibold text-foreground">{t('notFound.title')}</h1>
        <p className="mt-2 text-muted">{t('notFound.description')}</p>
        <Button onPress={() => navigate(authRoutes.signIn)} className="mt-8">
          {t('notFound.backToHome')}
        </Button>
      </div>
    </>
  );
}
